import { HttpError } from "../../../commons/erorrs/errors";

export const SUBSCRIBE = "subscribe";
export const UNSUBSCRIBE = "unsubscribe";
export const DYNAMIC_ANALYSIS_EMPTY_MESSAGES = Object.freeze({
  dropped_files: "Dropped Files Doesn't Exist For This Analysis",
  network_analysis: "Network Data Doesn't Exist for This Analysis.",
  mitre_attack: "Mitre Attack Data Doesn't Exist for This Analysis",
  snort_alerts: "Snort Alerts Data Doesn't Exist for This Analysis",
  sigma_detections: "Sigma Detections Data Doesn't Exist for This Analysis",
  malware_configurations: {
    no_data: "Malware Configurations Data Doesn't Exist for This Analysis",
    no_config: "No Configuration Data Available",
    no_network: "No Network Data Available"
  },
  signatures: "Signatures Data Doesn't Exist for This Analysis",
  suricata_alerts: "Suricata Alerts Data Doesn't Exist for This Analysis"
});

export const PAGE_SIZES = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "40", value: "40" },
  { label: "100", value: "100" }
];

export enum DROPPED_FILES_ACTIONS {
  DOWNLOAD = "Download Dropped Files",
  DOWNLOAD_SHORT = "Download",
  SEND_TO_STATIC_ANALYSIS = "Send Dropped Files to Static Analysis",
  SEND_TO_STATIC_ANALYSIS_SHORT = "Send to Static Analysis",
  DOWNLOAD_LATEST = "Download Latest Dropped Files",
  DOWNLOAD_LATEST_SHORT = "Download Latest",
  SEND_LATEST_TO_STATIC_ANALYSIS = "Send Latest Dropped Files to Static Analysis",
  SEND_LATEST_TO_STATIC_ANALYSIS_SHORT = "Send Latest to Static Analysis"
}

export const SCREENSHOT_ERROR_MAP: Record<string | number, string> = {
  [HttpError.HTTP_404]: "Screenshots not found for this analysis.",
  [HttpError.HTTP_429]:
    "Exceeding disk or memory usage, check system health status for more information.",
  [HttpError.HTTP_50X]: "Unexpected error occurred while fetching screenshots."
};
